var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"c-portfolio-map-and-kpis",class:{ 'c-portfolio-map-and-kpis--horizontal': _vm.layout === 'horizontal' }},[_c('PortfolioMapContainer',{attrs:{"buildings":_vm.buildings,"portfolio":_vm.portfolio,"layout":_vm.layout}}),_c('PortfolioKpis',{attrs:{"portfolio":_vm.portfolio,"chart-data":_vm.chartData,"layout":_vm.layout}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }